// @第三方登入: 統一賦予第三方登入註冊服務要用的應用 key 值
export default {
  // 登入完後要導向哪頁
  REDIRECT_URI: 'https://gawbue.lale.im/gawbueVue/index.html',
  // REDIRECT_URI: 'http://localhost:8080', // 本地端測試用
  // --------- Line 的應用資訊 ----------
  LINE_CLIENT_ID: '1656637798', // 開發平台對應的頻道ID
  LINE_CLIENT_SECRET: '0752acb1294dcaa441c6a86aba06735e', // 開發平台對應的頻道Secret Code

  // --------- FB 的應用資訊 ------------
  FB_APP_ID: '385484006659699', // 在 FB開發人員後台的 應用程式編號
  FB_CLIENT_SECRET: '240c9fc8db39bf20224577c7805ca014' // 在 FB開發人員後台的 應用程式密鑰
};
